export default __webpack_public_path__ + "static/media/fa-brands-400.f3a4f7eb.eot";